import { getCuratorUserInfo } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetCuratorUserInfoServiceResponse } from './user-info.dto';
import { GetCuratorUserInfoServiceResponseSchema } from './user-info.dto';

// NOTE: 현재 인증된 큐레이터 사용자 정보 조회 서비스
export const getCuratorUserInfoService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetCuratorUserInfoServiceResponse> => {
    const { meta, data } = await getCuratorUserInfo();

    if (meta?.result === 'FAIL') {
      throw new Error(meta?.message ?? '사용자 정보 조회 중 에러가 발생했습니다.');
    }

    // Service Layer DTO로 변환하여 반환
    const response: GetCuratorUserInfoServiceResponse = {
      platform: data.platformCode,
      userId: data.platformMemberUid,
      registeredDate: data.registeredDate ?? undefined,
      snsTitle: data.snsTitle ?? undefined,
    };

    return response;
  }, validateServiceResponse(GetCuratorUserInfoServiceResponseSchema)),
);
